import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  BaseText,
  ContentDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Investment',
  setup(__props) {

const changeAmountValue = inject(
  'changeAmountValue',
  (value: number, formatted: string) => ({ value, formatted })
);

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const amountFormatted = ref('');
const amountValue = ref(0);

const isDisabled = computed(() => {
  return amountValue.value <= 0 || status.value === 'error';
});

const minimumInvestment = computed(() => {
  return investmentDetails.value.minimumInvestment.value;
});

const availableBalance = computed(() => {
  return investmentDetails.value.availableBalance.value;
});

const status = computed(() => {
  return (amountValue.value < minimumInvestment.value &&
    amountValue.value !== 0) ||
    amountValue.value > availableBalance.value
    ? 'error'
    : '';
});

const helperText = computed(() => {
  if (amountValue.value < minimumInvestment.value && amountValue.value !== 0)
    return `O valor mínimo de investimento nesta carteira é ${investmentDetails.value.minimumInvestment.formatted}`;
  if (amountValue.value > availableBalance.value)
    return `Valor maior que o saldo disponível: ${investmentDetails.value.availableBalance.formatted}`;

  return '';
});

function investClick() {
  changeAmountValue(amountValue.value, amountFormatted.value);
}

function onChangeValue(data: { value: number; formatted: string }) {
  amountFormatted.value = data.formatted;
  amountValue.value = data.value;
}

return { __sfc: true,changeAmountValue, investmentDetails, amountFormatted, amountValue, isDisabled, minimumInvestment, availableBalance, status, helperText, investClick, onChangeValue, HeadingDisplay, BaseText, ContentDisplay, ListDisplay, ButtonContainer, ButtonPrimary, NebraskaColors, SingleInputMoney }
}

})